import type { Build } from "../lib/api";

/**
 * How a build is NAMED, everywhere it appears.
 *
 * The team says "R2"; the page showed only commit shas. Found by the CEO mid-install of a security
 * release — "you mean 7295b0a? it's hard to tell that's R2". So the human label leads and the sha
 * follows as the precise-but-unmemorable half.
 *
 * A build with no release name shows its version and sha rather than a placeholder: an unnamed
 * build is a real state (nobody has written its notes yet), not a defect to paper over.
 */
export function BuildLabel({ build }: { build: Build }) {
  const name = build.info?.release_name?.trim();
  return (
    <span>
      {name ? <strong>{name}</strong> : <span className="muted">unnamed build</span>}
      {" · "}
      {build.version_name ?? "?"}
      {build.commit_sha && (
        <>
          {" · "}
          <code>{build.commit_sha}</code>
        </>
      )}
      {build.variant_exp && (
        <>
          {" · "}
          <span className="chip">
            {build.variant_exp}/{build.variant_id}
          </span>
        </>
      )}
    </span>
  );
}
